/**
 * Auto-generated by Style Dictionary from DTCG tokens.
 * DO NOT EDIT — run `nx run tokens:code` to regenerate.
 *
 * @generated
 */

export const components = {
  chip: {
    background: {
      '@': '#0e0d240a',
      disabled: '#0e0d2414',
      hover: '#0e0d2414',
      selected: '#0e0d241f',
    },
    border: {
      '@': '#0e0d2429',
      focus: '#793690',
    },
    borderWidth: 1,
    deleteIcon: {
      colour: {
        hover: '#17172b',
      },
    },
    filled: {
      background: {
        '@': '#484885',
        hover: '#484885',
        selected: '#484885',
      },
      error: {
        background: {
          '@': '#ce1c25',
          hover: '#ce1c25',
          selected: '#ce1c25',
        },
        label: {
          '@': '#f8f8fa',
          selected: '#f8f8fa',
        },
      },
      info: {
        background: {
          '@': '#0158f9',
          hover: '#0158f9',
          selected: '#0158f9',
        },
        label: {
          '@': '#f8f8fa',
          selected: '#f8f8fa',
        },
      },
      label: '#f8f8fa',
      primary: {
        background: {
          '@': '#793690',
          hover: '#793690',
          selected: '#793690',
        },
        label: {
          '@': '#f8f8fa',
          selected: '#f8f8fa',
        },
      },
      success: {
        background: {
          '@': '#1b7936',
          hover: '#1b7936',
          selected: '#1b7936',
        },
        label: {
          '@': '#f8f8fa',
          selected: '#f8f8fa',
        },
      },
      warning: {
        background: {
          '@': '#bd4f00',
          hover: '#bd4f00',
          selected: '#bd4f00',
        },
        label: {
          '@': '#f8f8fa',
          selected: '#f8f8fa',
        },
      },
    },
    icon: {
      colour: '#484885',
    },
    label: {
      '@': '#17172b',
      disabled: '#00000052',
    },
    outlined: {
      background: {
        hover: '#0e0d2414',
        selected: '#0e0d24',
      },
      error: {
        background: {
          '@': '#fdf6f6',
          hover: '#ce1c251a',
          selected: '#ce1c25',
        },
        border: {
          '@': '#ce1c25',
          selected: '#ce1c25',
        },
        label: {
          '@': '#9d151c',
          selected: '#f8f8fa',
        },
      },
      info: {
        background: {
          '@': '#f5f8ff',
          hover: '#0158f91a',
          selected: '#0158f9',
        },
        border: {
          '@': '#0158f9',
          selected: '#0158f9',
        },
        label: {
          '@': '#0143bd',
          selected: '#f8f8fa',
        },
      },
      label: '#17172b',
      primary: {
        background: {
          '@': '#faf7fb',
          hover: '#7936901a',
          selected: '#793690',
        },
        border: {
          '@': '#793690',
          selected: '#793690',
        },
        label: {
          '@': '#793690',
          selected: '#f8f8fa',
        },
      },
      success: {
        background: {
          '@': '#f6faf7',
          hover: '#1b79361a',
          selected: '#1b7936',
        },
        border: {
          '@': '#1b7936',
          selected: '#1b7936',
        },
        label: {
          '@': '#155c29',
          selected: '#f8f8fa',
        },
      },
      warning: {
        background: {
          '@': '#fcf8f5',
          hover: '#bd4f001a',
          selected: '#bd4f00',
        },
        border: {
          '@': '#bd4f00',
          selected: '#bd4f00',
        },
        label: {
          '@': '#903c00',
          selected: '#f8f8fa',
        },
      },
    },
    radius: 1000000000,
    selected: {
      background: '#0e0d24',
      label: '#f8f8fa',
    },
    size: {
      large: {
        avatarPaddingLeft: 4,
        avatarSize: 32,
        gap: -16,
        height: 40,
        iconPaddingX: 12,
        paddingX: 12,
      },
      medium: {
        avatarPaddingLeft: 4,
        avatarSize: 24,
        gap: -12,
        height: 32,
        iconPaddingX: 8,
        paddingX: 8,
      },
      small: {
        avatarPaddingLeft: 4,
        avatarSize: 18,
        gap: -12,
        height: 24,
        iconPaddingX: 8,
        paddingX: 8,
      },
    },
    soft: {
      background: {
        '@': '#0e0d240a',
        hover: '#0e0d2414',
        selected: '#0e0d24',
      },
      error: {
        background: {
          '@': '#f9e3e4',
          hover: '#ce1c251a',
          selected: '#ce1c25',
        },
        label: {
          '@': '#42090c',
          selected: '#f8f8fa',
        },
      },
      info: {
        background: {
          '@': '#e0ebfe',
          hover: '#0158f91a',
          selected: '#0158f9',
        },
        label: {
          '@': '#001c50',
          selected: '#f8f8fa',
        },
      },
      label: '#17172b',
      primary: {
        background: {
          '@': '#efe7f2',
          hover: '#7936901a',
          selected: '#793690',
        },
        label: {
          '@': '#27112e',
          selected: '#f8f8fa',
        },
      },
      success: {
        background: {
          '@': '#e3efe7',
          hover: '#1b79361a',
          selected: '#1b7936',
        },
        label: {
          '@': '#092711',
          selected: '#f8f8fa',
        },
      },
      warning: {
        background: {
          '@': '#f7eae0',
          hover: '#bd4f001a',
          selected: '#bd4f00',
        },
        label: {
          '@': '#3d1900',
          selected: '#f8f8fa',
        },
      },
    },
  },
} as const;
